module.exports = "<div class=\"subscriber-div\" #subscriberDiv></div>\n"